import { Instance, SnapshotOut, types } from "mobx-state-tree";
import { BoundedNameModel } from "../../models/BoundedNameModel";

export const AllowedDomainModel = types.model("AllowedDomainModel", {
  id: types.string,
  domainName: BoundedNameModel,
  domain: BoundedNameModel,
});

export const createAllowedDomainModel = (
  allowedDomain: SnapshotOut<typeof AllowedDomainModel>,
): Instance<typeof AllowedDomainModel> =>
  AllowedDomainModel.create(allowedDomain);
